export default __webpack_public_path__ + "static/media/Tunic of the Silent Slayer.6bccf788.jpg";